import autobind from 'autobind-decorator';
import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { ModalWrapper } from '@shared/ui-components';

import { KreoDialogActions } from 'common/UIKit';
import { DialogWrapper } from 'common/UIKit/dialogs/dialog-wrapper';
import { BillingPeriodUnit } from '../../../enums/billing-period-unit';
import { SubscriptionAddon } from '../../../interfaces/subscription-addon';
import { SubscriptionPlanVariantWithName } from '../../../interfaces/subscription-plan-variant-with-name';
import { SubscriptionListing } from '../../subscription-listing';
import { Styled } from './styled';

export const SELECT_SUBSCRIPTION_PLAN__DIALOG = 'SELECT_SUBSCRIPTION_PLAN__DIALOG';

interface DispatchProps {
  closeDialog: () => void;
}

interface Props extends DispatchProps {
  filteredPlanGroups: SubscriptionPlanVariantWithName[];
  filteredAddons: SubscriptionAddon[];
  selectedAddons: SubscriptionAddon[];
  selectedPlanGroup: string;
  billingPeriod: BillingPeriodUnit;
  selectedAddonGroups: string[];
  onSubscriptionPlanGroupClick: (groupName: string) => void;
  onSelectedAddonGroupsChanged: (selectedAddonGroups: string[]) => void;
  onBillingPeriodChanged: (billingPeriod: BillingPeriodUnit) => void;
}

class SelectSubscriptionPlanDialogComponent extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.state = { teamSize: 1 };
  }

  public render(): JSX.Element {
    return (
      <DialogWrapper name={SELECT_SUBSCRIPTION_PLAN__DIALOG}>
        <ModalWrapper onExit={this.onClose}>
          <Styled.Container>
            <SubscriptionListing
              filteredPlanGroups={this.props.filteredPlanGroups}
              filteredAddons={this.props.filteredAddons}
              selectedAddons={this.props.selectedAddons}
              selectedPlanGroup={this.props.selectedPlanGroup}
              billingPeriod={this.props.billingPeriod}
              selectedAddonGroups={this.props.selectedAddonGroups}
              onSubscriptionPlanGroupClick={this.onSubscriptionPlanGroupClick}
              onSelectedAddonGroupsChanged={this.props.onSelectedAddonGroupsChanged}
              onBillingPeriodChanged={this.props.onBillingPeriodChanged}
            />
          </Styled.Container>
        </ModalWrapper>
      </DialogWrapper>
    );
  }

  @autobind
  private onSubscriptionPlanGroupClick(groupName: string): void {
    this.props.onSubscriptionPlanGroupClick(groupName);
    this.onClose();
  }

  @autobind
  private onClose(): void {
    this.props.closeDialog();
  }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>): DispatchProps {
  return {
    closeDialog: () => dispatch(KreoDialogActions.closeDialog(SELECT_SUBSCRIPTION_PLAN__DIALOG)),
  };
}

const connector = connect(null, mapDispatchToProps);
export const SelectSubscriptionPlanDialog = connector(SelectSubscriptionPlanDialogComponent);
